/**
 * IK Online - Aboservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type AboDocumentSourceType = 'AboDocumentSourceBusinessObjects' | 'AboDocumentSourceCelum' | 'AboDocumentSourceLVZ';

export const AboDocumentSourceType = {
    AboDocumentSourceBusinessObjects: 'AboDocumentSourceBusinessObjects' as AboDocumentSourceType,
    AboDocumentSourceCelum: 'AboDocumentSourceCelum' as AboDocumentSourceType,
    AboDocumentSourceLvz: 'AboDocumentSourceLVZ' as AboDocumentSourceType
};

